export const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production'

const API_URL = process.env.REACT_APP_ENVIRONMENT === 'production' ? 'https://3d-mcvn.merchize.com' : 'https://tool3d-staging-mcvn.merchize.com'
const FACTORY_API_URL = process.env.REACT_APP_ENVIRONMENT === 'production' ? 'https://factory-mcvn.merchize.com' : 'https://f1-staging-mcvn.merchize.com'

const config = {
    development: {
        url: API_URL,
        factory_url: FACTORY_API_URL,
    },
    production: {
        url: API_URL,
        factory_url: FACTORY_API_URL,
    },
    test: {
        url: API_URL,
        factory_url: FACTORY_API_URL,
    }
}

const nodeEnv = process.env.NODE_ENV || 'development'

export default config[nodeEnv]
